/**
 * @generated SignedSource<<5751252b2904737853220702140076b0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type BrowseChannelsModalLeaveChannelMutation$variables = {
  channelId: string;
};
export type BrowseChannelsModalLeaveChannelMutation$data = {
  readonly leaveChannel: {
    readonly channel: {
      readonly id: string;
      readonly isMember: boolean;
      readonly members: ReadonlyArray<{
        readonly email: string;
        readonly fullName: string;
        readonly id: string;
        readonly image: string;
      }>;
    };
  } | null;
};
export type BrowseChannelsModalLeaveChannelMutation = {
  response: BrowseChannelsModalLeaveChannelMutation$data;
  variables: BrowseChannelsModalLeaveChannelMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "channelId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "channelId",
        "variableName": "channelId"
      }
    ],
    "concreteType": "LeaveChannel",
    "kind": "LinkedField",
    "name": "leaveChannel",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Channel",
        "kind": "LinkedField",
        "name": "channel",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isMember",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "members",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "email",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fullName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "image",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BrowseChannelsModalLeaveChannelMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BrowseChannelsModalLeaveChannelMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "11deb1a04d28b76674d1435c81259621",
    "id": null,
    "metadata": {},
    "name": "BrowseChannelsModalLeaveChannelMutation",
    "operationKind": "mutation",
    "text": "mutation BrowseChannelsModalLeaveChannelMutation(\n  $channelId: ID!\n) {\n  leaveChannel(channelId: $channelId) {\n    channel {\n      id\n      isMember\n      members {\n        id\n        email\n        fullName\n        image\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3562b571a4aff260d127e66b44c614b9";

export default node;
